import React from "react"
import { useSelector } from "react-redux"
import { webApi } from "../../lib/WebApi"
import {
    Modal,
    ModalTitle,
    TitleSection,
    ContentSection,
    FooterSection,
    Label,
    Button,
    Row,
    Column,
    Color,
} from "trux"
import { useHistory } from "react-router-dom"

export const RemoveFamily = (props) => {
    const history = useHistory()
    const family = useSelector((state) => state.family.value)
    const user_id = props.match.params.user_id

    const players = family
        .filter((member) => {
            if (member.relation === "child") {
                return member.user_id
            }
        })
        .map((a) => a.user_id)
    // const playerIds = players.map((a) => a.user_id)

    const handleCloseButtonClick = (e) => {
        e.preventDefault()
        history.goBack()
    }

    const userRelats = async (user_id) => {
        let response = await webApi._get(
            `/webapp/users/${user_id}/relations`,
            {}
        )
        return response
    }

    const removeRelation = async (relation_id) => {
        webApi._post(`/webapp/user-relations/${relation_id}/delete`, {})
    }
    const onRemoveFamilyMember = async () => {
        for (let player of players) {
            let userR = await userRelats(player)

            for (let fam of userR) {
                if (fam.related_user.user_id === parseInt(user_id)) {
                    await removeRelation(fam.user_relationship_id)

                    history.goBack()
                    if (props.match.params) {
                        setTimeout(() => {
                            window.location.reload(true)
                        }, 200)
                    }
                }
            }
        }
    }

    return (
        <Modal
            className="RemoveFamily"
            open
            onShadeClick={(e) => {
                handleCloseButtonClick(e)
            }}
        >
            <TitleSection onCloseClick={handleCloseButtonClick}>
                <ModalTitle content={"Remove family member?"} />
            </TitleSection>
            <ContentSection>
                <Label
                    center
                    type={Label.Type.Body}
                    color={Color.Charcoal40}
                    marginBottom="4"
                    content="You will remove this family member from your Trace family.
                    You can always invite them back if you need to."
                />
            </ContentSection>
            <FooterSection>
                <Button
                    width="100%"
                    className="cancel-button"
                    content={"No, cancel"}
                />

                <Button
                    width="100%"
                    className="remove-button"
                    content={"Yes, remove family member"}
                    onClick={onRemoveFamilyMember}
                />
            </FooterSection>
        </Modal>
    )
}
